'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = BaseReducer;

var _utils = require('helpers/utils');

var _querystring = require('querystring');

var _config = require('config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BaseReducer(entity, name) {
  var ADD = entity + '/ADD';
  var LOAD = entity + '/LOAD';
  var LOAD_FAIL = entity + '/LOAD_FAIL';
  var LOAD_SUCCESS = entity + '/LOAD_SUCCESS';
  var LOAD_TOPS = entity + '/LOAD_TOPS';
  var LOAD_TOPS_FAIL = entity + '/LOAD_TOPS_FAIL';
  var LOAD_TOPS_SUCCESS = entity + '/LOAD_TOPS_SUCCESS';
  var SET_SELECTED = entity + '/SET_SELECTED';
  var SET_MENU = entity + '/SET_MENU';
  var TOGGLE_DISCLOSED = entity + '/TOGGLE_DISCLOSED';
  var SET_SHOW_ALL = entity + '/SET_SHOW_ALL';
  var SET_TREE_VIEW = entity + '/SET_TREE_VIEW';

  var config = _config.app.entities[entity];
  var initialData = config.initialData || [];
  var initialState = {
    data: initialData,
    config: config,
    loaded: false,
    loading: false,
    menu: [],
    selected: [],
    disclosed: [],
    showAll: config.showAll !== undefined ? config.showAll : false,
    treeView: config.treeView !== undefined ? config.treeView : false,
    tops: {
      loaded: false,
      loading: false,
      items: []
    }
  };

  function toggleItem(sourceList, item) {
    var index = sourceList.indexOf(item);
    switch (index > -1) {
      case true:
        // Present
        sourceList.splice(index, 1);
        break;
      case false: // Absent
      default:
        sourceList.push(item);
    }
    return sourceList;
  }

  function mergeEntities(toMerge, target) {
    var parsedData = toMerge.map(function (ent) {
      return {
        group: entity,
        id: ent.id,
        label: ent.name,
        name: ent.name,
        parent_id: ent.parent_id,
        references: ent.references || 0,
        tag: name
      };
    });

    return (0, _utils.mergeCollections)(parsedData, target);
  }

  return {
    reducer: function reducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      switch (action.type) {
        case ADD:
          return (0, _extends3.default)({}, state, {
            data: (0, _utils.findInCollectionOrAdd)(action.item, state.data)
          });
        case LOAD:
          return (0, _extends3.default)({}, state, {
            loaded: false,
            loading: true
          });
        case LOAD_FAIL:
          return (0, _extends3.default)({}, state, {
            loaded: false,
            loading: false
          });
        case LOAD_SUCCESS:
          var data = void 0;
          // This exists only because all LOAD, LOAD_TOPS and INDEX merge
          // results between executions, which is useful to keep an history
          // of existing values for filters, but not for lists.
          // We should eventually refactor this to always keep a merged list
          // of seen items, and a separate collection of active items.
          var newData = [];
          if (Array.isArray(action.result)) {
            action.result.forEach(function (aData) {
              newData = newData.concat(aData.data);
            });
          } else {
            newData = action.result.data;
          }

          if (action.flush) {
            data = newData;
          } else {
            data = newData ? mergeEntities(newData, state.data) : newData;
          }

          return (0, _extends3.default)({}, state, {
            data: data,
            loaded: true,
            loading: false
          });
        case LOAD_TOPS:
          var newLoadTops = {
            items: [],
            loaded: false,
            loading: true
          };
          return (0, _extends3.default)({}, state, {
            tops: newLoadTops
          });
        case LOAD_TOPS_FAIL:
          var newLoadTopsFail = {
            items: [],
            loaded: false,
            loading: false
          };
          return (0, _extends3.default)({}, state, {
            tops: newLoadTopsFail
          });
        case LOAD_TOPS_SUCCESS:
          var newLoadTopsSuccess = {
            items: action.result.data ? mergeEntities(action.result.data, state.tops.items) : state.tops.items,
            loaded: true,
            loading: false
          };
          return (0, _extends3.default)({}, state, {
            data: action.result.data ? mergeEntities(action.result.data, state.data) : state.data,
            loaded: true,
            loading: false,
            tops: newLoadTopsSuccess
          });
        case TOGGLE_DISCLOSED:
          return (0, _extends3.default)({}, state, {
            disclosed: toggleItem(state.disclosed, action.value)
          });
        case SET_MENU:
          var filteredCollection = (0, _utils.filterCollectionFromParams)(state.data, action.menu);

          return (0, _extends3.default)({}, state, {
            menu: config.menuOrder ? (0, _utils.orderByField)(filteredCollection, config.menuOrder) : filteredCollection
          });
        case SET_SELECTED:
          return (0, _extends3.default)({}, state, {
            selected: (0, _utils.filterCollectionFromParams)(state.data, action.selected)
          });
        case SET_SHOW_ALL:
          return (0, _extends3.default)({}, state, {
            showAll: action.value
          });
        case SET_TREE_VIEW:
          return (0, _extends3.default)({}, state, {
            treeView: action.value
          });
        default:
          return state;
      }
    },
    add: function add(object) {
      return {
        type: ADD,
        item: object
      };
    },
    areTopsLoaded: function areTopsLoaded(globalState) {
      return globalState[entity] && globalState[entity].tops && globalState[entity].tops.loaded;
    },
    index: function index(showAll, treeView) {
      var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var flush = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var querystring = (0, _querystring.stringify)((0, _assign2.default)({}, {
        direction: showAll ? 'asc' : 'desc',
        order: showAll ? 'name' : 'references',
        per: 1000
      }, query));

      var promise = void 0;
      if (!showAll) {
        if (treeView) {
          promise = function promise(client) {
            return client.get('/calendars/' + process.env.CALENDAR_ID + ('/' + entity + '?' + querystring)).then(function (res) {
              var fetchedIds = [];
              var parentIds = [];

              res.data.forEach(function (eId) {
                fetchedIds.push(eId.id);
                if (eId.parent_id) {
                  parentIds.push(eId.parent_id);
                }
              });

              var unfetchedIds = parentIds.filter(function (pId) {
                return fetchedIds.indexOf(pId) === -1;
              });

              if (unfetchedIds.length > 0) {
                return _promise2.default.all([res, client.get('/' + entity + '?id=' + unfetchedIds)]);
              }

              return res;
            });
          };
        } else {
          promise = function promise(client) {
            return client.get('/calendars/' + process.env.CALENDAR_ID + ('/' + entity + '?' + querystring));
          };
        }
      } else {
        promise = function promise(client) {
          return client.get('/' + entity + '?' + querystring);
        };
      }

      return {
        types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
        flush: flush,
        promise: promise
      };
    },
    isLoaded: function isLoaded(globalState) {
      return globalState[entity] && globalState[entity].loaded;
    },
    isMenuProvided: function isMenuProvided() {
      return Array.isArray(config.menu) && config.menu.length > 0;
    },
    isMenuRequired: function isMenuRequired() {
      return config.inFilters;
    },
    load: function load(ids) {
      if (!Array.isArray(ids)) {
        return { type: LOAD_FAIL };
      }

      return {
        types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
        promise: function promise(client) {
          return client.get('/calendars/' + process.env.CALENDAR_ID + ('/' + entity + '?id=' + ids.join(',')));
        }
      };
    },
    loadTops: function loadTops() {
      return {
        types: [LOAD_TOPS, LOAD_TOPS_SUCCESS, LOAD_TOPS_FAIL],
        promise: function promise(client) {
          return client.get('/calendars/' + process.env.CALENDAR_ID + ('/' + entity + '?order=references&direction=desc&per=' + (config.limit || 10)));
        }
      };
    },
    toggleDisclosed: function toggleDisclosed(value) {
      return {
        type: TOGGLE_DISCLOSED,
        value: value
      };
    },
    setMenu: function setMenu(menu) {
      return {
        type: SET_MENU,
        menu: menu
      };
    },
    setSelected: function setSelected(selected) {
      return {
        type: SET_SELECTED,
        selected: Array.isArray(selected) ? selected : (0, _utils.splitIdsList)(selected)
      };
    },
    setShowAll: function setShowAll(value) {
      return {
        type: SET_SHOW_ALL,
        value: value
      };
    },
    setTreeView: function setTreeView(value) {
      return {
        type: SET_TREE_VIEW,
        value: value
      };
    }
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/base.js
// module id = 128
// module chunks = 0